import api from '../axiosConfig';

const API_URL = '/api/raw-stock-history';

export const fetchRawStockHistory = () => api.get(API_URL);
export const fetchRawStockHistoryByStockCode = (stockCode) => api.get(`${API_URL}/stock-code/${stockCode}`);
export const fetchRawStockHistoryByDateRange = (dateFrom, dateTo) => api.get(`${API_URL}/date-range?dateFrom=${dateFrom}&dateTo=${dateTo}`);
export const fetchRawStockHistoryByCreatedBy = (createdBy) => api.get(`${API_URL}/created-by/${createdBy}`);
export const createRawStockHistory = (data) => api.post(API_URL, data);
export const getRawStockHistoryReport = (filters) => api.get(`${API_URL}/report`, { params: filters }); 